module.exports = __webpack_public_path__ + "img/policies-papers.926d4ec1.png";